import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";

export interface GetTopAppsReportRequestParamsDto {
    startDate: string;
    endDate: string;
    timezone: string;
    granularity?: CubeTimeDimensionGranularity;
}